import { Avatar, AvatarFallback } from "ui/components/avatar";

import { RenderAvatar } from "./render-avatar";
import classNames from "classnames";
import { formatName } from "utils";

export function RenderProfile({ user, className }) {
  return (
    <span className="flex gap-2 items-center">
      <Avatar className={classNames("size-7 rounded-full", className)}>
        <RenderAvatar user={user} alt={user?.first_name} />
      </Avatar>
      {formatName(user)}
    </span>
  );
}
